import { useParams } from 'react-router';

import { getLogo } from './utils';

export function LogoSmall() {
  const { group = '' } = useParams();
  const src = getLogo({ group, size: 'small' });

  return <img width="30" src={src} alt="logo" />;
}
